// src/components/atoms/SubmissionDetails/CommentItem.js

import React from "react";
import { Box, Typography } from "@mui/material";

const CommentItem = ({ comment }) => {
  return (
    <Box sx={{ mt: 3, mb: 2 }}>
      {/* Commenter's Name */}
      <Typography
        variant="body1"
        sx={{
          fontWeight: "bold",
          textDecoration: "underline",
          mb: 1,
          ml: 3,
          fontFamily: "basic-sans",
        }}
      >
        {comment.createdBy}
      </Typography>

      {/* Comment Box */}
      <Box
        sx={{
          p: 3,
          backgroundColor: "rgba(30, 65, 255, 0.25)",
          borderRadius: 4,
          color: "white",
        }}
      >
        <Typography
          variant="body1"
          sx={{ fontFamily: "basic-sans", lineHeight: "1.8em" }}
        >
          {comment.text}
        </Typography>
      </Box>
    </Box>
  );
};

export default CommentItem;
